module.exports = new __parcel__URL__("btn_facebook.6fc3bc73.png").toString();